"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTitleText = exports.StyledConsolidatedListContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledConsolidatedListContainer = styled_components_1.default.div `
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  row-gap: ${({ theme }) => theme.spacing(0.5)};
  column-gap: ${({ theme }) => theme.spacing(2)};

  .list-column {
    display: grid;
    grid-template-columns: max-content minmax(max-content, 200px);
    grid-auto-rows: min-content;
    row-gap: ${({ theme }) => theme.spacing(0.5)};
    column-gap: ${({ theme }) => theme.spacing(2)};
    color: ${({ theme }) => theme.palette.text.primary};

    .list-value {
      max-width: 200px;
      color: ${({ theme }) => theme.palette.text.secondary};
      font-size: 0.875rem;
      line-height: 1.43;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;
exports.StyledTitleText = (0, styled_components_1.default)(ui_components_1.Typography) `
  font-weight: 700;
`;
